import { setupEnv, setupYup } from "@ascend-ltd/accounts-core";
import { japanizeZodErrorMap } from "@ascend-ltd/logic-helpers";
import z from "zod/v4";
import { CurrentConfig } from "./config";
import { setupSentry } from "./utils/sentry";

export const setup = async () => {
  await setupEnv(CurrentConfig.env);
  await setupSentry();
  setupYup();
  z.config({
    ...z.locales.ja(),
    customError: japanizeZodErrorMap,
  });
};
